module.exports = __webpack_public_path__ + "img/tosse_lenco.4620377c.svg";